import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import NoDataStoreAlert from "../../components/NoDataStoreAlert";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useGroup } from "../../domain/crud";
import { useGroupParams } from "../../paths";
import { selectData } from "../../utils";
import GroupForm from "./components/EditForm";

export default function EditGroup() {
  const { groupId } = useGroupParams();
  const groupQuery = useGroup(groupId, { select: selectData });

  const group = groupQuery.data;
  return (
    <>
      <Helmet>
        <title>Edit Group</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="Edit Group"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              <NoDataStoreAlert sx={{ mb: 4 }} />
              {group ? (
                <GroupForm group={group} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
